import { Component, HostListener, Input } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';

import { Lecture } from '../../lectures/shared/lecture';
import { LectureLessonService } from '../../lectures/shared/lecture-lesson.service';
import { ConfirmDialogButtonBase } from '../../shared/base/confirm-dialog-button-base';
import { MESSAGE_COMMON_ERROR } from '../../shared/message';
import { Lesson } from '../shared/lesson';
import { MESSAGE_REMOVE_LESSON_SUCCESS } from '../shared/lesson-message';
import { LessonService } from '../shared/lesson.service';

@Component({
  selector: 'app-lesson-remove-button',
  template: '<ng-content></ng-content>'
})
export class LessonRemoveButtonComponent extends ConfirmDialogButtonBase {
  @Input() lecture: Lecture;
  @Input() lesson: Lesson;

  constructor(dialog: MatDialog, snackBar: MatSnackBar,
    private router: Router, private route: ActivatedRoute,
    private service: LessonService,
    private refService: LectureLessonService) {
    super(dialog, snackBar);
  }

  @HostListener('click') onClick() {
    this.openDialog();
  }

  openDialog(): void {
    super.openDialog('Lesson 삭제', `${this.lesson.name} Lesson을 삭제하시겠습니까?`, '삭제', '취소');
  }

  async onSubmit() {
    try {
      await this.refService.readRef(this.lecture.$key, this.lesson.$key).remove();
      this.closeDialog();
      this.openSnackBar(MESSAGE_REMOVE_LESSON_SUCCESS);
      this.router.navigate(['./'], {relativeTo: this.route.parent.parent});
      await this.service.remove(this.lesson.$key);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/lesson-remove-button/lesson-remove-button.component.ts